import {CSSProperties} from "react";
import {Clickable} from "interfaces";
import {AVATAR_PLACEHOLDER} from "utils/avatar-placeholder";

interface AvatarProps extends CSSProperties, Partial<Clickable> {
  src: string;
  alt?: string;
  size?: number;
}

export const Avatar: React.FC<AvatarProps> = (props) => {
  const {src, size = 50, alt = "avatar", onClick, ...cssStyle} = props;
  return (
    <img
      alt={alt}
      width={size}
      height={size}
      onClick={onClick}
      src={src || AVATAR_PLACEHOLDER}
      style={{objectFit: "cover", borderRadius: 100, ...cssStyle}}
      onError={({currentTarget}) => {
        currentTarget.src = "/images/placeholder/avatar.png";
      }}
    />
  );
};
